/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Catalog Api
 * REST api
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiDiscountsGetCollection200,
  ApiDiscountsGetCollectionParams,
  Discount,
  DiscountJsonld
} from './schemas';

import { apiCatalog } from '../../apiCatalog';



// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type api_discounts_get_collectionResponse200 = {
  data: ApiDiscountsGetCollection200
  status: 200
}

export type api_discounts_get_collectionResponseSuccess = (api_discounts_get_collectionResponse200) & {
  headers: Headers;
};
;

export type api_discounts_get_collectionResponse = (api_discounts_get_collectionResponseSuccess)

export const getApiDiscountsGetCollectionUrl = (params?: ApiDiscountsGetCollectionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/discounts?${stringifiedParams}` : `/api/discounts`
}

/**
 * Retrieves the collection of Discount resources.
 * @summary Retrieves the collection of Discount resources.
 */
export const api_discounts_get_collection = async (params?: ApiDiscountsGetCollectionParams, options?: RequestInit): Promise<api_discounts_get_collectionResponse> => {

  return apiCatalog<api_discounts_get_collectionResponse>(getApiDiscountsGetCollectionUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getApiDiscountsGetCollectionQueryKey = (params?: ApiDiscountsGetCollectionParams,) => {
    return [
    `/api/discounts`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiDiscountsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof api_discounts_get_collection>>, TError = unknown>(params?: ApiDiscountsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_discounts_get_collection>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDiscountsGetCollectionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof api_discounts_get_collection>>> = ({ signal }) => api_discounts_get_collection(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof api_discounts_get_collection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDiscountsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof api_discounts_get_collection>>>
export type ApiDiscountsGetCollectionQueryError = unknown


export function useApiDiscountsGetCollection<TData = Awaited<ReturnType<typeof api_discounts_get_collection>>, TError = unknown>(
 params: undefined |  ApiDiscountsGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_discounts_get_collection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof api_discounts_get_collection>>,
          TError,
          Awaited<ReturnType<typeof api_discounts_get_collection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDiscountsGetCollection<TData = Awaited<ReturnType<typeof api_discounts_get_collection>>, TError = unknown>(
 params?: ApiDiscountsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_discounts_get_collection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof api_discounts_get_collection>>,
          TError,
          Awaited<ReturnType<typeof api_discounts_get_collection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDiscountsGetCollection<TData = Awaited<ReturnType<typeof api_discounts_get_collection>>, TError = unknown>(
 params?: ApiDiscountsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_discounts_get_collection>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Discount resources.
 */

export function useApiDiscountsGetCollection<TData = Awaited<ReturnType<typeof api_discounts_get_collection>>, TError = unknown>(
 params?: ApiDiscountsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_discounts_get_collection>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDiscountsGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type api_discounts_postResponse201 = {
  data: DiscountJsonld
  status: 201
}

export type api_discounts_postResponse400 = {
  data: void
  status: 400
}

export type api_discounts_postResponse422 = {
  data: void
  status: 422
}

export type api_discounts_postResponseSuccess = (api_discounts_postResponse201) & {
  headers: Headers;
};
export type api_discounts_postResponseError = (api_discounts_postResponse400 | api_discounts_postResponse422) & {
  headers: Headers;
};

export type api_discounts_postResponse = (api_discounts_postResponseSuccess | api_discounts_postResponseError)

export const getApiDiscountsPostUrl = () => {




  return `/api/discounts`
}

/**
 * Creates a Discount resource.
 * @summary Creates a Discount resource.
 */
export const api_discounts_post = async (apiDiscountsPostBody: NonReadonly<DiscountJsonld | Discount>, options?: RequestInit): Promise<api_discounts_postResponse> => {

  return apiCatalog<api_discounts_postResponse>(getApiDiscountsPostUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: JSON.stringify(apiDiscountsPostBody)
  }
);}





export const getApiDiscountsPostMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_discounts_post>>, TError,{data: NonReadonly<DiscountJsonld | Discount>}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof api_discounts_post>>, TError,{data: NonReadonly<DiscountJsonld | Discount>}, TContext> => {

const mutationKey = ['apiDiscountsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof api_discounts_post>>, {data: NonReadonly<DiscountJsonld | Discount>}> = (props) => {
          const {data} = props ?? {};

          return  api_discounts_post(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDiscountsPostMutationResult = NonNullable<Awaited<ReturnType<typeof api_discounts_post>>>
    export type ApiDiscountsPostMutationBody = NonReadonly<DiscountJsonld | Discount>
    export type ApiDiscountsPostMutationError = void

    /**
 * @summary Creates a Discount resource.
 */
export const useApiDiscountsPost = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_discounts_post>>, TError,{data: NonReadonly<DiscountJsonld | Discount>}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof api_discounts_post>>,
        TError,
        {data: NonReadonly<DiscountJsonld | Discount>},
        TContext
      > => {
      return useMutation(getApiDiscountsPostMutationOptions(options), queryClient);
    }
    export type api_discounts_id_getResponse200 = {
  data: DiscountJsonld
  status: 200
}

export type api_discounts_id_getResponse404 = {
  data: void
  status: 404
}

export type api_discounts_id_getResponseSuccess = (api_discounts_id_getResponse200) & {
  headers: Headers;
};
export type api_discounts_id_getResponseError = (api_discounts_id_getResponse404) & {
  headers: Headers;
};

export type api_discounts_id_getResponse = (api_discounts_id_getResponseSuccess | api_discounts_id_getResponseError)

export const getApiDiscountsIdGetUrl = (id: string,) => {




  return `/api/discounts/${id}`
}

/**
 * Retrieves a Discount resource.
 * @summary Retrieves a Discount resource.
 */
export const api_discounts_id_get = async (id: string, options?: RequestInit): Promise<api_discounts_id_getResponse> => {

  return apiCatalog<api_discounts_id_getResponse>(getApiDiscountsIdGetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getApiDiscountsIdGetQueryKey = (id: string,) => {
    return [
    `/api/discounts/${id}`
    ] as const;
    }


export const getApiDiscountsIdGetQueryOptions = <TData = Awaited<ReturnType<typeof api_discounts_id_get>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_discounts_id_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDiscountsIdGetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof api_discounts_id_get>>> = ({ signal }) => api_discounts_id_get(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof api_discounts_id_get>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDiscountsIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof api_discounts_id_get>>>
export type ApiDiscountsIdGetQueryError = void


export function useApiDiscountsIdGet<TData = Awaited<ReturnType<typeof api_discounts_id_get>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_discounts_id_get>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof api_discounts_id_get>>,
          TError,
          Awaited<ReturnType<typeof api_discounts_id_get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDiscountsIdGet<TData = Awaited<ReturnType<typeof api_discounts_id_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_discounts_id_get>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof api_discounts_id_get>>,
          TError,
          Awaited<ReturnType<typeof api_discounts_id_get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDiscountsIdGet<TData = Awaited<ReturnType<typeof api_discounts_id_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_discounts_id_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a Discount resource.
 */

export function useApiDiscountsIdGet<TData = Awaited<ReturnType<typeof api_discounts_id_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_discounts_id_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDiscountsIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type api_discounts_id_putResponse200 = {
  data: DiscountJsonld
  status: 200
}

export type api_discounts_id_putResponse400 = {
  data: void
  status: 400
}

export type api_discounts_id_putResponse404 = {
  data: void
  status: 404
}

export type api_discounts_id_putResponse422 = {
  data: void
  status: 422
}

export type api_discounts_id_putResponseSuccess = (api_discounts_id_putResponse200) & {
  headers: Headers;
};
export type api_discounts_id_putResponseError = (api_discounts_id_putResponse400 | api_discounts_id_putResponse404 | api_discounts_id_putResponse422) & {
  headers: Headers;
};

export type api_discounts_id_putResponse = (api_discounts_id_putResponseSuccess | api_discounts_id_putResponseError)

export const getApiDiscountsIdPutUrl = (id: string,) => {




  return `/api/discounts/${id}`
}

/**
 * Replaces the Discount resource.
 * @summary Replaces the Discount resource.
 */
export const api_discounts_id_put = async (id: string,
    apiDiscountsIdPutBody: NonReadonly<DiscountJsonld | Discount>, options?: RequestInit): Promise<api_discounts_id_putResponse> => {

  return apiCatalog<api_discounts_id_putResponse>(getApiDiscountsIdPutUrl(id),
  {
    ...options,
    method: 'PUT'
    ,
    body: JSON.stringify(apiDiscountsIdPutBody)
  }
);}





export const getApiDiscountsIdPutMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_discounts_id_put>>, TError,{id: string;data: NonReadonly<DiscountJsonld | Discount>}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof api_discounts_id_put>>, TError,{id: string;data: NonReadonly<DiscountJsonld | Discount>}, TContext> => {

const mutationKey = ['apiDiscountsIdPut'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof api_discounts_id_put>>, {id: string;data: NonReadonly<DiscountJsonld | Discount>}> = (props) => {
          const {id,data} = props ?? {};

          return  api_discounts_id_put(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDiscountsIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof api_discounts_id_put>>>
    export type ApiDiscountsIdPutMutationBody = NonReadonly<DiscountJsonld | Discount>
    export type ApiDiscountsIdPutMutationError = void

    /**
 * @summary Replaces the Discount resource.
 */
export const useApiDiscountsIdPut = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_discounts_id_put>>, TError,{id: string;data: NonReadonly<DiscountJsonld | Discount>}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof api_discounts_id_put>>,
        TError,
        {id: string;data: NonReadonly<DiscountJsonld | Discount>},
        TContext
      > => {
      return useMutation(getApiDiscountsIdPutMutationOptions(options), queryClient);
    }
    export type api_discounts_id_deleteResponse204 = {
  data: void
  status: 204
}

export type api_discounts_id_deleteResponse404 = {
  data: void
  status: 404
}

export type api_discounts_id_deleteResponseSuccess = (api_discounts_id_deleteResponse204) & {
  headers: Headers;
};
export type api_discounts_id_deleteResponseError = (api_discounts_id_deleteResponse404) & {
  headers: Headers;
};

export type api_discounts_id_deleteResponse = (api_discounts_id_deleteResponseSuccess | api_discounts_id_deleteResponseError)

export const getApiDiscountsIdDeleteUrl = (id: string,) => {




  return `/api/discounts/${id}`
}

/**
 * Removes the Discount resource.
 * @summary Removes the Discount resource.
 */
export const api_discounts_id_delete = async (id: string, options?: RequestInit): Promise<api_discounts_id_deleteResponse> => {

  return apiCatalog<api_discounts_id_deleteResponse>(getApiDiscountsIdDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getApiDiscountsIdDeleteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_discounts_id_delete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof api_discounts_id_delete>>, TError,{id: string}, TContext> => {

const mutationKey = ['apiDiscountsIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof api_discounts_id_delete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  api_discounts_id_delete(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDiscountsIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof api_discounts_id_delete>>>

    export type ApiDiscountsIdDeleteMutationError = void

    /**
 * @summary Removes the Discount resource.
 */
export const useApiDiscountsIdDelete = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_discounts_id_delete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof api_discounts_id_delete>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getApiDiscountsIdDeleteMutationOptions(options), queryClient);
    }
    export type api_discounts_id_patchResponse200 = {
  data: DiscountJsonld
  status: 200
}

export type api_discounts_id_patchResponse400 = {
  data: void
  status: 400
}

export type api_discounts_id_patchResponse404 = {
  data: void
  status: 404
}

export type api_discounts_id_patchResponse422 = {
  data: void
  status: 422
}

export type api_discounts_id_patchResponseSuccess = (api_discounts_id_patchResponse200) & {
  headers: Headers;
};
export type api_discounts_id_patchResponseError = (api_discounts_id_patchResponse400 | api_discounts_id_patchResponse404 | api_discounts_id_patchResponse422) & {
  headers: Headers;
};

export type api_discounts_id_patchResponse = (api_discounts_id_patchResponseSuccess | api_discounts_id_patchResponseError)

export const getApiDiscountsIdPatchUrl = (id: string,) => {




  return `/api/discounts/${id}`
}

/**
 * Updates the Discount resource.
 * @summary Updates the Discount resource.
 */
export const api_discounts_id_patch = async (id: string,
    discount: NonReadonly<Discount>, options?: RequestInit): Promise<api_discounts_id_patchResponse> => {

  return apiCatalog<api_discounts_id_patchResponse>(getApiDiscountsIdPatchUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/merge-patch+json', ...options?.headers },
    body: JSON.stringify(discount)
  }
);}





export const getApiDiscountsIdPatchMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_discounts_id_patch>>, TError,{id: string;data: NonReadonly<Discount>}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof api_discounts_id_patch>>, TError,{id: string;data: NonReadonly<Discount>}, TContext> => {

const mutationKey = ['apiDiscountsIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof api_discounts_id_patch>>, {id: string;data: NonReadonly<Discount>}> = (props) => {
          const {id,data} = props ?? {};

          return  api_discounts_id_patch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDiscountsIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof api_discounts_id_patch>>>
    export type ApiDiscountsIdPatchMutationBody = NonReadonly<Discount>
    export type ApiDiscountsIdPatchMutationError = void

    /**
 * @summary Updates the Discount resource.
 */
export const useApiDiscountsIdPatch = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_discounts_id_patch>>, TError,{id: string;data: NonReadonly<Discount>}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof api_discounts_id_patch>>,
        TError,
        {id: string;data: NonReadonly<Discount>},
        TContext
      > => {
      return useMutation(getApiDiscountsIdPatchMutationOptions(options), queryClient);
    }
